var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#222222",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.7253 5.31261c-4.2093-1.03074-9.28018.57636-11.07709 3.51377-.93664 1.53092-.85573 3.25062.22653 4.84432.12012.2151.26341.4141.42715.5931.74494-1.8852 2.05644-3.4482 3.72551-4.44004.1682-.10615.3849-.04571.4838.13492.0989.18062.0427.41322-.1257.51942-1.66913 1.0531-2.78117 2.2979-3.46708 4.1813-.48022 1.2523-.80215 2.568-.95722 3.912-.02265.207.11249.3957.30471.4254.02317.0032.0466.0041.0699.0023.16801-.0124.30444-.1502.32619-.3293.12802-1.201.40463-2.3782.8226-3.5005.45305.2465.9356.4246 1.43395.5293.15065.0312.30055.056.44965.0743 1.3447.1862 2.702-.2217 3.7612-1.1301 1.1144-1.2801 1.2212-2.4328 1.3246-3.5476.1327-1.43526.2704-2.91953 2.4366-5.138.0941-.09644.1313-.24067.0967-.37531s-.1351-.23816-.262-.26928z",
    fill: "#2d2d2d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForest);
export default __webpack_public_path__ + "static/media/forest.b42609ff31cc6b89e32530086c4d68bf.svg";
export { ForwardRef as ReactComponent };